import React, {Component} from 'react';

export default class Banner extends Component {

    render() {

        if(typeof this.props.src === 'undefined' || this.props.src === '') {
            return null;
        }

        return (
            <div style={{
                width: '100%',
                height: '100%',
                // backgroundImage: 'url('+this.props.src+')'
            }}>
                <img src={this.props.src} style={{width: "100%"}} alt ={''}/>
            </div>
        )
    }
}
